/* Anime Wars: S-KUN popup + leaderboard. Loaded (defer) only when the theme kill switch is on.
 * Everything initialises in requestIdleCallback. ?wars=mock uses built-in data with the API's shapes. */
(function () {
  'use strict';
  var cfgEl = document.querySelector('[data-ssc-wars-config]');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  // The API URL comes from a free-text theme setting: force an absolute https URL with no trailing slash,
  // e.g. "anime-wars-delta.vercel.app/", "https:/x.app" or "//x.app" all become "https://x.app".
  function normalizeApi(raw) {
    var u = String(raw || '').trim();
    if (!u) return '';
    u = u.replace(/^[a-z][a-z0-9+.-]*:\/*/i, '').replace(/^\/+/, '');
    return ('https://' + u).replace(/\/+$/, '');
  }
  CFG.api = normalizeApi(CFG.api);
  var MOCK = /(?:^|[?&])wars=mock(?:&|$)/.test(location.search);
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var THRESHOLD = 25;

  /* ---------------------------------------------------------------- utils */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function store(kind) {
    var s = null;
    try { s = window[kind]; var k = '__ssc_wars_t'; s.setItem(k, '1'); s.removeItem(k); } catch (e) { s = null; }
    return {
      ok: !!s,
      get: function (k) { try { return s ? s.getItem(k) : null; } catch (e) { return null; } },
      set: function (k, v) { try { if (s) s.setItem(k, v); } catch (e) { /* ignore */ } },
      remove: function (k) { try { if (s) s.removeItem(k); } catch (e) { /* ignore */ } },
    };
  }
  var LS = store('localStorage');
  var SS = store('sessionStorage');
  function nySeasonId(d) {
    try {
      var p = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit' }).formatToParts(d || new Date());
      var y = '', m = '';
      p.forEach(function (x) { if (x.type === 'year') y = x.value; if (x.type === 'month') m = x.value; });
      return y + '-' + m;
    } catch (e) { var n = d || new Date(); return n.getFullYear() + '-' + String(n.getMonth() + 1).padStart(2, '0'); }
  }
  function monthName(id) {
    var parts = String(id || '').split('-');
    var names = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return names[(Number(parts[1]) || 1) - 1];
  }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g, '').replace(/['’`]/g, '').replace(/[^a-z0-9]+/g, ' ').trim(); }
  function animeInfo(slug) { return (CFG.anime && CFG.anime[slug]) || null; }
  function slugForName(name) {
    var n = norm(name);
    for (var k in CFG.anime) if (norm(CFG.anime[k].name) === n) return k;
    return null;
  }
  function worldVar(key) { return 'var(--world-' + (key || 'default') + ')'; }

  /* ---------------------------------------------------------------- mock data */
  var MOCK_BOARD = (function () {
    var rows = [['one-piece', 4812], ['demon-slayer', 4390], ['jujutsu-kaisen', 3655], ['naruto', 3102], ['bleach', 3102], ['dragon-ball', 1920],
      ['black-clover', 1306], ['blue-lock', 1150], ['jojos-bizarre-adventure', 890], ['hunter-x-hunter', 760], ['attack-on-titan', 640], ['fire-force', 520],
      ['my-hero-academia', 430], ['solo-leveling', 380], ['tokyo-ghoul', 290], ['fullmetal-alchemist', 240], ['berserk', 190], ['baki', 130], ['chainsaw-man', 110], ['one-punch-man', 80]];
    var id = nySeasonId();
    var y = Number(id.slice(0, 4)), m = Number(id.slice(5));
    var end = new Date(Date.UTC(m === 12 ? y + 1 : y, m === 12 ? 0 : m, 1, 4, 0, 0));
    return {
      season: { id: id, ends_at: end.toISOString() },
      anime: rows.map(function (r) { var a = animeInfo(r[0]) || { name: r[0], world: 'default' }; return { slug: r[0], name: a.name, world_key: a.world, total: r[1] }; }),
      writeins: [{ name: 'Sakamoto Days', votes: 31 }],
      rising: [{ name: 'Frieren', votes: 18 }, { name: 'Kaiju No. 8', votes: 7 }],
      writein_threshold: THRESHOLD,
      entrants_count: 12873,
    };
  })();
  var MOCK_ALIASES = { 'jujutsu-kaisen': ['jjk'], 'one-piece': ['op'], 'dragon-ball': ['dbz', 'db', 'dbs'], 'my-hero-academia': ['mha', 'bnha'], 'attack-on-titan': ['aot', 'snk'],
    'hunter-x-hunter': ['hxh'], 'fullmetal-alchemist': ['fma', 'fmab'], 'jojos-bizarre-adventure': ['jojo', 'jjba'], 'demon-slayer': ['kny'] };
  function mockVote(body) {
    // Test hooks: an email containing "already", "uk" (non-US), "fail" (network error) or "bad" (400).
    var email = String(body.email || '');
    if (/fail/.test(email)) return Promise.reject(new Error('mock network'));
    if (/bad/.test(email) || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return Promise.resolve({ status: 400, data: { error: 'Enter a valid email.' } });
    var eligible = !/uk/.test(email);
    if (body.writein) return Promise.resolve({ status: 200, data: { status: 'counted', anime: body.writein, rank: null, total: 1, eligible: eligible, writein: true } });
    var i = MOCK_BOARD.anime.findIndex(function (a) { return a.slug === body.anime_slug; });
    var a = MOCK_BOARD.anime[i] || MOCK_BOARD.anime[0];
    if (/already/.test(email)) return Promise.resolve({ status: 200, data: { status: 'already', anime: 'Naruto', rank: 4, total: 3102, eligible: eligible, writein: false } });
    return Promise.resolve({ status: 200, data: { status: 'counted', anime: a.name, rank: i + 1, total: a.total + 1, eligible: eligible, writein: false } });
  }

  /* ---------------------------------------------------------------- api */
  function getJSON(path) {
    if (MOCK) {
      if (path === '/api/board') return Promise.resolve(JSON.parse(JSON.stringify(MOCK_BOARD)));
      if (path === '/api/anime') return Promise.resolve({ anime: MOCK_BOARD.anime.map(function (a) { return { slug: a.slug, name: a.name, world_key: a.world_key, aliases: MOCK_ALIASES[a.slug] || [] }; }) });
    }
    var ctl = 'AbortController' in window ? new AbortController() : null;
    var t = ctl ? setTimeout(function () { ctl.abort(); }, 8000) : 0;
    return fetch(CFG.api + path, { signal: ctl ? ctl.signal : undefined, credentials: 'omit' })
      .then(function (r) { clearTimeout(t); if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }
  function postVote(body) {
    if (MOCK) return mockVote(body);
    return fetch(CFG.api + '/api/vote', { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (data) { return { status: r.status, data: data }; }); });
  }
  var boardPromise = null;
  var BOARD_TTL = 5 * 60 * 1000;
  function loadBoard(force) {
    // A board fetched in the last 5 minutes this session is reused (menu, Character select, collection card, PDP line).
    if (!boardPromise && !force && !MOCK) {
      try {
        var fresh = JSON.parse(SS.get('ssc-wars-board') || 'null');
        if (fresh && fresh.board && Date.now() - fresh.at < BOARD_TTL) boardPromise = Promise.resolve(fresh.board);
      } catch (e) { /* ignore */ }
    }
    if (!boardPromise || force) {
      boardPromise = getJSON('/api/board').then(function (b) {
        SS.set('ssc-wars-board', JSON.stringify({ at: Date.now(), board: b }));
        return b;
      }).catch(function (e) {
        boardPromise = null;
        var cached = SS.get('ssc-wars-board');
        if (cached) { try { var c = JSON.parse(cached); c.board.stale = true; return c.board; } catch (x) { /* ignore */ } }
        throw e;
      });
    }
    return boardPromise;
  }
  var animePromise = null;
  function loadAnime() {
    if (!animePromise) animePromise = getJSON('/api/anime').then(function (r) { return r.anime || []; }).catch(function () { animePromise = null; return []; });
    return animePromise;
  }

  /* ---------------------------------------------------------------- css */
  var cssPromise = null;
  function ensureCss() {
    if (cssPromise) return cssPromise;
    if (document.querySelector('link[data-ssc-wars-css]')) { cssPromise = Promise.resolve(); return cssPromise; }
    cssPromise = new Promise(function (resolve) {
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = CFG.css;
      l.setAttribute('data-ssc-wars-css', '');
      l.onload = resolve;
      l.onerror = resolve;
      document.head.appendChild(l);
    });
    return cssPromise;
  }

  /* ---------------------------------------------------------------- S-KUN */
  /* S-KUN Ink Ninja: one inline <template> per mood in snippets/ssc-wars-npc.liquid. */
  function face(mood) {
    var t = document.querySelector('template[data-ssc-wars-face="' + mood + '"]') || document.querySelector('template[data-ssc-wars-face="idle"]');
    return t ? t.innerHTML : '';
  }

  var uid = 0;
  function Npc(host, opts) {
    this.host = host;
    this.inline = !!opts.inline;
    this.onClose = opts.onClose || function () {};
    this.step = opts.step || 0;
    this.pick = null;           // {slug,name,world} or {writein:'…'}
    this.searching = false;
    this.query = '';
    this.result = null;
    this.error = '';
    this.busy = false;
    this.board = null;
    this.id = 'ssc-wars-name-' + (++uid);
    this.el = document.createElement('div');
    this.el.className = 'ssc-wars' + (this.inline ? ' ssc-wars--inline' : ' ssc-wars--float');
    this.el.setAttribute('role', 'dialog');
    this.el.setAttribute('aria-modal', 'false');
    this.el.setAttribute('aria-labelledby', this.id);
    host.appendChild(this.el);
    var self = this;
    this.el.addEventListener('click', function (e) { self.click(e); });
    this.el.addEventListener('input', function (e) {
      if (e.target && e.target.matches('[data-q]')) { self.query = e.target.value; self.renderSuggestions(); }
    });
    this.el.addEventListener('submit', function (e) { e.preventDefault(); self.submit(e.target); });
    this.el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !self.inline) { e.stopPropagation(); self.close(true); }
    });
  }
  Npc.prototype.topEight = function () {
    var list = (this.board && this.board.anime) || [];
    if (!list.length) list = Object.keys(CFG.anime).map(function (k) { return { slug: k, name: CFG.anime[k].name, world_key: CFG.anime[k].world, total: 0 }; });
    return list.slice(0, 8);
  };
  // Hello = idle, Pick = wink, Locked in = happy; already voted, non-US or any error = shock.
  Npc.prototype.mood = function () {
    if (this.step === 0) return 'idle';
    if (this.step === 1) return 'wink';
    if (this.step === 2) return this.error ? 'shock' : 'idle';
    var r = this.result || {};
    if (r.status === 'already' || r.eligible === false) return 'shock';
    return 'happy';
  };
  Npc.prototype.pickName = function () { return this.pick ? (this.pick.writein || this.pick.name) : ''; };
  Npc.prototype.render = function (focus) {
    var s = this.step, html = '';
    var pickName = esc(this.pickName());
    if (s === 0) {
      html = '<p class="ssc-wars__say">Yo! We need your help settling the biggest debate on the internet. <b>What\'s the greatest anime of all time?</b><span class="ssc-wars__cursor" aria-hidden="true"></span></p>' +
        '<div class="ssc-wars__opts"><button type="button" class="ssc-wars__o ssc-wars__o--y" data-go="1">Cast my vote <span aria-hidden="true">▶</span></button>' +
        '<button type="button" class="ssc-wars__o" data-later>Maybe later</button></div>';
    } else if (s === 1) {
      html = '<p class="ssc-wars__say">Choose wisely. Your pick gets your vote <b>every month</b>.</p>';
      if (this.searching) {
        html += '<div class="ssc-wars__addf"><input type="text" data-q placeholder="Search all anime or add yours" aria-label="Search any anime" maxlength="40" value="' + esc(this.query) + '"><div class="ssc-wars__sug" data-sug></div></div>';
      } else {
        var self = this;
        html += '<div class="ssc-wars__picks">' + this.topEight().map(function (a) {
          var on = self.pick && self.pick.slug === a.slug;
          return '<button type="button" class="ssc-wars__pk" style="--c:' + worldVar(a.world_key) + '" data-pick="' + esc(a.slug) + '" aria-pressed="' + on + '">' + esc(a.name) + '</button>';
        }).join('');
        var w = this.pick && this.pick.writein;
        var other = this.pick && !w && !this.topEight().some(function (a) { return a.slug === self.pick.slug; });
        html += '<button type="button" class="ssc-wars__pk ssc-wars__pk--add" data-search aria-pressed="' + !!(w || other) + '">' + (w || other ? pickName : '+ More anime / add yours') + '</button></div>';
      }
      html += '<div class="ssc-wars__opts"><button type="button" class="ssc-wars__o ssc-wars__o--y" data-go="2"' + (this.pick ? '' : ' disabled') + '>' + (this.pick ? 'Vote ' + pickName : 'Pick one') + ' <span aria-hidden="true">▶</span></button></div>';
    } else if (s === 2) {
      html = '<p class="ssc-wars__say">Lock in your vote for <b>' + pickName + '</b>. Drop your email so we can count it and enter you in this month\'s giveaway.</p>' +
        '<form class="ssc-wars__em" novalidate><label class="ssc-wars__vh" for="' + this.id + '-em">Email</label>' +
        '<input id="' + this.id + '-em" type="email" name="email" autocomplete="email" inputmode="email" placeholder="you@email.com" required>' +
        '<span class="ssc-wars__hp" aria-hidden="true"><label>Leave this empty <input type="text" name="hp" tabindex="-1" autocomplete="off"></label></span>' +
        '<button type="submit"' + (this.busy ? ' disabled' : '') + '>' + (this.busy ? '…' : 'Vote') + '</button></form>' +
        (this.error ? '<p class="ssc-wars__err" role="alert">' + esc(this.error) + '</p>' : '') +
        '<span class="ssc-wars__fine">One vote per email each month. No purchase needed to enter. US residents 18+ for the giveaway. We\'ll send drops and deals; unsubscribe anytime. <a href="' + esc(CFG.rules) + '">Official rules</a></span>';
    } else if (s === 3) {
      html = this.resultHtml();
    }
    var close = this.inline ? '' : '<button type="button" class="ssc-wars__x" data-close aria-label="Close Anime Wars">✕</button>';
    this.el.innerHTML = face(this.mood()) + '<div class="ssc-wars__box"><span class="ssc-wars__name" id="' + this.id + '">S-KUN</span>' + close + html + '</div>';
    if (this.searching && s === 1) this.renderSuggestions();
    if (focus) {
      var f = this.el.querySelector(focus === 'input' ? 'input:not([type=hidden]):not([name=hp])' : 'button:not([disabled]):not([data-close]), input');
      if (f) f.focus({ preventScroll: true });
    }
  };
  Npc.prototype.resultHtml = function () {
    var r = this.result || {};
    var name = esc(r.anime || this.pickName());
    var slug = (this.pick && this.pick.slug) || slugForName(r.anime);
    var info = slug ? animeInfo(slug) : null;
    var lb = '<a class="ssc-wars__o" href="' + esc(CFG.page) + '">See the leaderboard</a>';
    var shop = info ? '<a class="ssc-wars__o ssc-wars__o--y" href="' + esc(info.url) + '">Shop ' + esc(info.name) + ' <span aria-hidden="true">▶</span></a>' : '';
    var html;
    if (r.status === 'already') {
      html = '<p class="ssc-wars__say">You already voted for <b>' + name + '</b> this month. Buy from it to power it up!</p><div class="ssc-wars__opts">' + shop + lb + '</div>';
    } else if (r.writein) {
      html = '<p class="ssc-wars__say">Write-in counted! <b>' + name + '</b> joins the board once it hits <b>' + THRESHOLD + ' votes</b>. Get your friends in.</p>' +
        '<div class="ssc-wars__opts"><button type="button" class="ssc-wars__o ssc-wars__o--y" data-share>Share <span aria-hidden="true">▶</span></button>' + lb + '</div>';
    } else {
      html = '<p class="ssc-wars__say">Vote counted! <b>' + name + '</b> is <b>#' + esc(r.rank || '?') + '</b> right now. Every item you buy from it adds another vote.</p>' +
        '<div class="ssc-wars__rank"><b>#' + esc(r.rank || '?') + '</b><span>' + name + '<br>' + Number(r.total || 0).toLocaleString('en-US') + ' votes</span></div>' +
        '<div class="ssc-wars__opts">' + shop + lb + '</div>';
    }
    if (r.eligible === false) html += '<p class="ssc-wars__fine">Your vote counts! The giveaway is US only.</p>';
    if (this.shareNote) html += '<p class="ssc-wars__fine" role="status">' + esc(this.shareNote) + '</p>';
    return html;
  };
  Npc.prototype.renderSuggestions = function () {
    var box = this.el.querySelector('[data-sug]');
    if (!box) return;
    var self = this;
    loadAnime().then(function (list) {
      if (!list.length) list = Object.keys(CFG.anime).map(function (k) { return { slug: k, name: CFG.anime[k].name, world_key: CFG.anime[k].world, aliases: [] }; });
      var q = norm(self.query);
      var matches = list.filter(function (a) {
        if (!q) return true;
        return norm(a.name).indexOf(q) !== -1 || (a.aliases || []).some(function (x) { return norm(x).indexOf(q) !== -1; });
      }).slice(0, q ? 6 : 19);
      var exact = q && list.some(function (a) { return norm(a.name) === q || (a.aliases || []).some(function (x) { return norm(x) === q; }); });
      var raw = self.query.trim().replace(/\s+/g, ' ');
      box.innerHTML = matches.map(function (a) {
        return '<button type="button" data-pick="' + esc(a.slug) + '" style="--c:' + worldVar(a.world_key) + '">' + esc(a.name) + '</button>';
      }).join('') + (q && !exact && raw.length >= 2 && raw.length <= 40 ? '<button type="button" class="ssc-wars__new" data-writein="' + esc(raw) + '">+ Add "' + esc(raw) + '"</button>' : '');
    });
  };
  Npc.prototype.click = function (e) {
    var t = e.target instanceof Element ? e.target.closest('button, a') : null;
    if (!t) return;
    var self = this;
    if (t.hasAttribute('data-close') || t.hasAttribute('data-later')) { this.close(true); return; }
    if (t.hasAttribute('data-go')) { this.step = Number(t.getAttribute('data-go')); this.error = ''; this.render(this.step === 2 ? 'input' : 'button'); return; }
    if (t.hasAttribute('data-search')) { this.searching = true; this.render('input'); return; }
    if (t.hasAttribute('data-pick')) {
      var slug = t.getAttribute('data-pick');
      var info = animeInfo(slug) || { name: t.textContent, world: 'default' };
      this.pick = { slug: slug, name: info.name, world: info.world };
      this.searching = false; this.query = '';
      this.render();
      var go = this.el.querySelector('[data-go="2"]'); if (go) go.focus({ preventScroll: true });
      return;
    }
    if (t.hasAttribute('data-writein')) {
      this.pick = { writein: t.getAttribute('data-writein') };
      this.searching = false; this.query = '';
      this.render();
      var go2 = this.el.querySelector('[data-go="2"]'); if (go2) go2.focus({ preventScroll: true });
      return;
    }
    if (t.hasAttribute('data-share')) {
      var url = location.origin + CFG.page;
      var text = 'Vote for ' + this.pickName() + ' in Anime Wars';
      if (navigator.share) { navigator.share({ title: 'Anime Wars', text: text, url: url }).catch(function () {}); return; }
      var done = function () { self.shareNote = 'Link copied. Send it to your friends!'; self.render(); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () { self.shareNote = url; self.render(); });
      else { this.shareNote = url; this.render(); }
    }
  };
  Npc.prototype.submit = function (form) {
    if (this.busy || this.step !== 2) return;
    var email = (form.elements.email.value || '').trim();
    var hp = form.elements.hp ? form.elements.hp.value : '';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { this.error = 'Enter a valid email.'; this.render('input'); return; }
    var body = { email: email, hp: hp };
    if (this.pick.writein) body.writein = this.pick.writein; else body.anime_slug = this.pick.slug;
    var self = this;
    this.busy = true; this.error = ''; this.render();
    postVote(body).then(function (res) {
      self.busy = false;
      if (res.status === 200 && res.data && (res.data.status === 'counted' || res.data.status === 'already')) {
        self.result = res.data;
        self.step = 3;
        LS.set('ssc-wars-voted', nySeasonId());
        if (self.pick && self.pick.slug) LS.set('ssc-wars-voted-slug', self.pick.slug);
        self.render('button');
        document.dispatchEvent(new CustomEvent('ssc-wars:voted', { detail: res.data }));
      } else {
        self.error = (res.data && res.data.error) || 'S-KUN dropped the scroll. Try again.';
        self.render('input');
        var input = self.el.querySelector('input[type=email]'); if (input) input.value = email;
      }
    }).catch(function () {
      self.busy = false;
      self.error = 'S-KUN dropped the scroll. Try again.';
      self.render('input');
      var input = self.el.querySelector('input[type=email]'); if (input) input.value = email;
    });
  };
  Npc.prototype.close = function (snooze) {
    if (snooze && !(this.result && this.step === 3)) LS.set('ssc-wars-snooze', String(Date.now() + 14 * 864e5));
    this.onClose(this);
  };

  /* ---------------------------------------------------------------- floating popup */
  // Prompt 129: never pops up by itself on a product page (on phones it landed over the size buttons); the vote button
  // and links still open it there.
  var EXCLUDED = /^\/(cart|checkout|checkouts|account|search|password|products\/|collections\/[^/]+\/products\/|pages\/(anime-wars|anime-wars-rules|bundler)(\/|$))/;
  var klaviyoOpened = false;
  window.addEventListener('klaviyoForms', function (e) {
    var type = e && e.detail && e.detail.type;
    if (type === 'open' || type === 'embedOpen') klaviyoOpened = true;
  });

  function blocker() {
    if (document.querySelector('dialog[open]')) return true;                 // quick add, size chart, search, cart drawer, chat drawer
    var cart = document.querySelector('#cart-drawer');
    if (cart && cart.hasAttribute('open')) return true;
    var menu = document.querySelector('[data-ssc-menu]');
    if (menu && !menu.hidden) return true;
    if (document.querySelector('.ssc-mto-overlay:not([hidden]), #ep.is-open')) return true;
    if (CFG.hideWithKlaviyo && klaviyoOpened) return true;
    return false;
  }
  function bottomLift() {
    // Sit above the sticky ATC, the B3G1 tracker, the added toast and the chat bubble (wherever it has been lifted to).
    var lift = window.innerWidth < 750 ? 76 : 16;
    var obstacles = document.querySelectorAll('.ssc-sticky, [data-ssc-trk]:not(.is-away):not([hidden]), [data-ssc-toast].is-on' + (window.innerWidth < 990 ? ', .Avada-Faqs_Button' : ''));
    for (var i = 0; i < obstacles.length; i++) {
      var o = obstacles[i];
      if (o.hidden || getComputedStyle(o).display === 'none') continue;
      var r = o.getBoundingClientRect();
      if (r.height > 0 && r.top < window.innerHeight && r.bottom > window.innerHeight - 260) lift = Math.max(lift, window.innerHeight - r.top + 10);
    }
    return lift;
  }

  var popup = null, layer = null, watch = 0;
  function openPopup(byUser) {
    if (popup) return;
    SS.set('ssc-wars-shown', '1');
    SS.set('ssc-popup-open', 'skun');
    shownThisLoad = true;
    ensureCss().then(function () {
      layer = document.createElement('div');
      layer.className = 'ssc-wars-layer';
      document.body.appendChild(layer);
      popup = new Npc(layer, { onClose: closePopup });
      popup.render(byUser ? 'button' : null);
      loadBoard().then(function (b) { if (popup) { popup.board = b; if (popup.step === 1 && !popup.searching) popup.render(); } }).catch(function () {});
      placeLayer();
      requestAnimationFrame(function () { if (layer) layer.classList.add('is-in'); });
      watch = setInterval(placeLayer, 400);
      document.addEventListener('keydown', onKey);
    });
  }
  function onKey(e) { if (e.key === 'Escape' && popup && layer && !blocker() && !layer.classList.contains('is-blocked')) popup.close(true); }
  function placeLayer() {
    if (!layer) return;
    var b = blocker();
    layer.classList.toggle('is-blocked', b);
    layer.setAttribute('aria-hidden', b ? 'true' : 'false');
    layer.style.bottom = bottomLift() + 'px';
  }
  function closePopup() {
    SS.remove('ssc-popup-open');
    clearInterval(watch);
    document.removeEventListener('keydown', onKey);
    if (!layer) return;
    var l = layer;
    layer = null; popup = null;
    l.classList.remove('is-in');
    setTimeout(function () { l.remove(); }, reduceMotion ? 0 : 260);
  }

  var shownThisLoad = false;
  window.addEventListener('pagehide', function () { if (popup) SS.remove('ssc-popup-open'); });
  function popupAllowed() {
    if (EXCLUDED.test(location.pathname)) return false;
    if (shownThisLoad) return false;
    if (SS.get('ssc-wars-shown') === '1') return false;
    if (Number(LS.get('ssc-wars-snooze') || 0) > Date.now()) return false;
    if (LS.get('ssc-wars-voted') === nySeasonId()) return false;
    return true;
  }
  function startTriggers() {
    if (!popupAllowed()) return;
    var now = Date.now();
    var start = Number(SS.get('ssc-wars-start') || 0);
    if (!start) { start = now; SS.set('ssc-wars-start', String(now)); }
    var views = Number(SS.get('ssc-wars-views') || 0) + 1;
    SS.set('ssc-wars-views', String(views));
    var scrolled = false;
    // From 990px the page scrolls inside .page-wrapper, not the window, so measure whichever scrolls.
    var wrapper = document.querySelector('.page-wrapper');
    function onScroll() {
      var room = document.documentElement.scrollHeight - window.innerHeight;
      var pos = window.scrollY;
      if (wrapper && wrapper.scrollHeight - wrapper.clientHeight > room) {
        room = wrapper.scrollHeight - wrapper.clientHeight;
        pos = wrapper.scrollTop;
      }
      if (room > 0 && pos / room >= 0.5) {
        scrolled = true;
        window.removeEventListener('scroll', onScroll);
        if (wrapper) wrapper.removeEventListener('scroll', onScroll);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    if (wrapper) wrapper.addEventListener('scroll', onScroll, { passive: true });
    // 12 s on site, and (a 50% scroll on a page or the 2nd page view); never on top of anything else.
    var timer = setInterval(function () {
      if (!popupAllowed()) { clearInterval(timer); return; }
      // The homepage email popup (snippets/scratch-popup.liquid) goes first: while it waits to open S-KUN waits too,
      // and once it has opened on this page view S-KUN leaves this view alone and tries on a later one.
      var email = window.sscEmailPopup;
      if (email && email.state === 'shown') { clearInterval(timer); return; }
      if (email && email.state === 'armed') return;
      var ready = Date.now() - start >= 12000 && (scrolled || views >= 2);
      if (ready && !blocker() && !document.hidden) { clearInterval(timer); openPopup(false); }
    }, 1000);
  }

  /* ---------------------------------------------------------------- leaderboard page */
  function initBoard(root) {
    var list = root.querySelector('[data-wars-list]');
    var more = root.querySelector('[data-wars-more]');
    var clock = root.querySelector('[data-wars-clock]');
    var monthEl = root.querySelector('[data-wars-month]');
    var risingBox = root.querySelector('[data-wars-rising]');
    var status = root.querySelector('[data-wars-status]');
    var prizeWrap = root.querySelector('[data-wars-prize]');
    var voteBtn = root.querySelector('[data-wars-vote]');
    var inlineHost = root.querySelector('[data-wars-inline]');
    var showAll = false, board = null, endsAt = null, prizeFor = null;

    function tick() {
      if (!clock || !endsAt) return;
      var ms = Math.max(0, endsAt - Date.now());
      var d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, m = Math.floor(ms / 6e4) % 60;
      clock.textContent = d > 0 ? d + 'd ' + h + 'h' : h + 'h ' + m + 'm';
    }
    function rows() {
      var items = board.anime.map(function (a) { var info = animeInfo(a.slug); return { name: a.name, total: a.total, world: a.world_key, url: info && info.url }; });
      (board.writeins || []).forEach(function (w) { items.push({ name: w.name, total: w.votes, world: 'default', url: null, writein: true }); });
      items.sort(function (x, y) { return y.total - x.total; });
      return items;
    }
    function render() {
      var all = rows();
      var top = all.length ? Math.max(1, all[0].total) : 1;
      var mine = LS.get('ssc-wars-voted') === nySeasonId() ? LS.get('ssc-wars-voted-slug') : null;
      var shown = showAll ? all : all.slice(0, 10);
      list.innerHTML = shown.map(function (a, i) {
        var pct = Math.round((a.total / top) * 100);
        var slug = !a.writein && slugForName(a.name);
        var inner = '<span class="ssc-wars-board__pos">' + (i + 1) + '</span>' +
          '<span class="ssc-wars-board__bar" style="--c:' + worldVar(a.world) + '"><span class="ssc-wars-board__fill" style="width:' + pct + '%"></span><span class="ssc-wars-board__name">' + esc(a.name) + '</span></span>' +
          '<span class="ssc-wars-board__votes">' + Number(a.total).toLocaleString('en-US') + '</span>';
        var cls = 'ssc-wars-board__it' + (mine && slug === mine ? ' is-mine' : '');
        return '<li class="' + cls + '">' + (a.url ? '<a href="' + esc(a.url) + '">' + inner + '</a>' : '<div>' + inner + '</div>') + '</li>';
      }).join('');
      if (more) {
        more.hidden = all.length <= 10;
        more.textContent = showAll ? 'Show top 10' : 'Show all ' + all.length + ' anime';
        more.setAttribute('aria-expanded', String(showAll));
      }
      if (risingBox) {
        var rising = board.rising || [];
        risingBox.hidden = !rising.length;
        var rl = risingBox.querySelector('[data-wars-rising-list]');
        if (rl) rl.innerHTML = rising.map(function (w) { return '<div><span>' + esc(w.name) + '</span><span>' + w.votes + ' / ' + (board.writein_threshold || THRESHOLD) + '</span></div>'; }).join('');
      }
      if (monthEl && board.season) monthEl.textContent = monthName(board.season.id);
      if (status) { status.hidden = !board.stale; status.textContent = board.stale ? 'Showing the last saved board. Live numbers are reloading.' : ''; }
      resolvePrize(all[0]);
    }
    function resolvePrize(first) {
      if (!prizeWrap || !first || first.writein || prizeFor === first.name) return;
      prizeFor = first.name;
      var info = animeInfo(slugForName(first.name));
      if (!info || info.url.indexOf('/collections/') === -1) return;
      fetch(info.url + '/products.json?limit=30', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (d) {
        var p = (d.products || []).filter(function (x) { return /mesh shorts/i.test(x.product_type || '') && x.images && x.images.length; })[0];
        if (!p) return;
        var src = p.images[0].src;
        var img = document.createElement('img');
        img.width = 72; img.height = 72; img.loading = 'lazy';
        var q = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=';
        img.src = q + 216;
        img.srcset = q + '72 72w, ' + q + '144 144w, ' + q + '216 216w';
        img.sizes = '72px';
        img.alt = p.title + ' mesh shorts';
        prizeWrap.replaceChildren(img);
      }).catch(function () {});
    }
    function load() {
      loadBoard(true).then(function (b) {
        board = b;
        if (b.season && b.season.ends_at) endsAt = new Date(b.season.ends_at).getTime();
        render(); tick();
      }).catch(function () {
        if (!board) {
          list.innerHTML = '<li class="ssc-wars-board__loading">Leaderboard reloading… S-KUN is fetching the latest numbers.</li>';
          if (more) more.hidden = true;
        }
        setTimeout(load, 30000);
      });
    }
    if (more) more.addEventListener('click', function () { showAll = !showAll; render(); });
    if (voteBtn && inlineHost) {
      voteBtn.addEventListener('click', function () {
        ensureCss().then(function () {
          inlineHost.hidden = false;
          inlineHost.innerHTML = '';
          var n = new Npc(inlineHost, { inline: true, step: 1, onClose: function () { inlineHost.hidden = true; } });
          n.board = board;
          n.render('button');
          voteBtn.hidden = true;
          inlineHost.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        });
      });
    }
    document.addEventListener('ssc-wars:voted', function () { setTimeout(load, 600); });
    load();
    setInterval(tick, 30000);
  }

  /* ---------------------------------------------------------------- scores on the menu, homepage, collections, PDP */
  // Standings from the board: competition ranking (ties share a place, shown "T-4th"). A place only shows once the world
  // has a vote and the season has at least 20 votes; before that the spots say voting is open. Nature
  // isn't on the board, so it never gets a line.
  var SEASON_MIN = 20;
  function ordinal(n) { var v = n % 100; return n + (v >= 11 && v <= 13 ? 'th' : ['th', 'st', 'nd', 'rd'][n % 10] || 'th'); }
  function standings(b) {
    var list = ((b && b.anime) || []).map(function (a) { return { key: a.world_key, name: a.name, v: Number(a.total) || 0 }; });
    list.sort(function (x, y) { return y.v - x.v; });
    var total = 0, by = {};
    list.forEach(function (x, i) {
      total += x.v;
      x.rank = i > 0 && list[i - 1].v === x.v ? list[i - 1].rank : i + 1;
    });
    list.forEach(function (x) {
      x.tied = list.filter(function (y) { return y.v === x.v; }).length > 1;
      if (x.key && x.key !== 'default' && !by[x.key]) by[x.key] = x;
    });
    var ends = b && b.season && b.season.ends_at ? new Date(b.season.ends_at).getTime() : 0;
    return {
      list: list, by: by, total: total, open: total >= SEASON_MIN,
      days: ends ? Math.max(0, Math.ceil((ends - Date.now()) / 864e5)) : null,
      month: b && b.season ? monthName(b.season.id) : ''
    };
  }
  var ST = null;
  function inWars(key) { return !!(ST && ST.by[key]); }
  function shows(key) { return !!(ST && ST.open && ST.by[key] && ST.by[key].v >= 1); }
  function place(key) { var x = ST.by[key]; return (x.tied ? 'T-' : '') + ordinal(x.rank); }
  function days() { return ST && ST.days != null ? ' · ' + ST.days + ' day' + (ST.days === 1 ? '' : 's') + ' left' : ''; }
  function rankChip(key) { var r = ST.by[key].rank; return '<span class="ssc-wrank' + (r <= 3 ? ' is-' + r : '') + '">' + place(key) + '</span>'; }
  function openLine(noLive) { return (noLive ? '' : '<span class="ssc-live">Live</span>') + '<span class="ssc-wline__txt">Voting is open' + days() + '</span><button type="button" class="ssc-wline__vote" data-wars-vote>Be the first ›</button>'; }
  // Collection score card body.
  function cardBody(key) {
    if (!inWars(key) || !shows(key)) return '<p class="ssc-wline">' + openLine(true) + '</p>';
    var me = ST.by[key];
    var above = null;
    for (var i = 0; i < ST.list.length; i++) if (ST.list[i].v > me.v) above = ST.list[i];
    var below = null;
    for (var j = 0; j < ST.list.length; j++) if (ST.list[j].v < me.v) { below = ST.list[j]; break; }
    var gap = above ? (above.v - me.v) + ' vote' + (above.v - me.v === 1 ? '' : 's') + ' behind ' + esc(above.name)
      : me.tied ? 'Tied for 1st' : 'Leading by ' + (me.v - (below ? below.v : 0)) + ' vote' + (me.v - (below ? below.v : 0) === 1 ? '' : 's');
    return '<div class="ssc-wscore__main">' + rankChip(key) + '<div><p class="ssc-wscore__votes"><b>' + me.v + '</b> votes this month</p>' +
      '<p class="ssc-wscore__gap">' + gap + days() + '</p></div></div>';
  }
  function paintScores() {
    document.querySelectorAll('[data-wars-medal]').forEach(function (el) {
      var k = el.getAttribute('data-wars-medal');
      var on = shows(k) && ST.by[k].rank <= 3;
      el.hidden = !on;
      if (on) { el.textContent = place(k); el.className = 'ssc-medal is-' + ST.by[k].rank; }
    });
    document.querySelectorAll('[data-wars-card]').forEach(function (card) {
      var body = card.querySelector('[data-wars-card-body]');
      if (body) body.innerHTML = cardBody(card.getAttribute('data-wars-card'));
      var m = card.querySelector('[data-wars-month]');
      if (m && ST.month) m.textContent = ST.month;
    });
    document.querySelectorAll('[data-wars-now]').forEach(function (el) {
      var k = el.getAttribute('data-wars-now');
      if (!shows(k)) return;
      // "· now 3rd" on the vote line, unless it would push the line onto a second row (layout shift): then a small
      // place tag on the world icon instead.
      var row = el.closest('.ssc-wars-pdp') || el.parentNode;
      var h = row.offsetHeight;
      el.textContent = ' · now ' + place(k);
      el.hidden = false;
      if (row.offsetHeight > h) {
        el.hidden = true;
        var ic = row.querySelector('.ssc-wars-pdp__ic');
        if (ic && !ic.querySelector('.ssc-medal')) {
          var tag = document.createElement('span');
          tag.className = 'ssc-medal is-' + Math.min(ST.by[k].rank, 4);
          tag.textContent = place(k);
          ic.appendChild(tag);
        }
      }
    });
  }
  function initScores() {
    if (!document.querySelector('[data-wars-medal], [data-wars-card], [data-wars-now], [data-ssc-cs]')) return;
    loadBoard().then(function (b) {
      ST = standings(b);
      window.SSCWars.ready = true;
      paintScores();
      document.dispatchEvent(new CustomEvent('ssc-wars:standings'));
    }).catch(function () {
      // No board: collection cards still say voting is open; medals, places and counts stay hidden.
      document.querySelectorAll('[data-wars-card-body]').forEach(function (b) { if (!b.innerHTML) b.innerHTML = '<p class="ssc-wline"><span class="ssc-wline__txt">Voting is open this month</span></p>'; });
    });
  }
  window.SSCWars = {
    loadBoard: loadBoard,
    ready: false,
    // Character select strip (prompt 77): the place pill, only when the world has a place (same rules as the medals).
    chip: function (key) { return shows(key) ? rankChip(key) : ''; },
    vote: function () { openPopup(true); }
  };
  document.addEventListener('click', function (e) {
    var v = e.target.closest && e.target.closest('[data-wars-vote]');
    if (!v) return;
    e.preventDefault();
    openPopup(true);
  });

  /* ---------------------------------------------------------------- boot */
  function boot() {
    var boardRoot = document.querySelector('[data-ssc-wars-board]');
    if (boardRoot) { initBoard(boardRoot); return; }
    initScores();
    startTriggers();
  }
  if ('requestIdleCallback' in window) window.requestIdleCallback(boot, { timeout: 4000 });
  else setTimeout(boot, 1);
})();
